import { render, staticRenderFns } from "./LandingSupport.vue?vue&type=template&id=b134ad7a&scoped=true"
import script from "./LandingSupport.vue?vue&type=script&lang=js"
export * from "./LandingSupport.vue?vue&type=script&lang=js"
import style0 from "./LandingSupport.vue?vue&type=style&index=0&id=b134ad7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b134ad7a",
  null
  
)

export default component.exports